import $ from 'jquery';

// The $.get and $.post counterpart for the verb Rails uses to delete records.
const ajaxWithMethod = (method) => (url, data, callback, type) => {
  // shift arguments if data argument was omitted
  if (typeof data === 'function') {
    type = type || callback;
    callback = data;
    data = undefined;
  }

  // url can be an options object (which then must have .url)
  return $.ajax(
    $.extend(
      {
        url,
        type: method,
        dataType: type,
        data,
        success: callback,
      },
      $.isPlainObject(url) && url
    )
  );
};

export const ajaxDelete = ajaxWithMethod('delete');
